var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"small mb-2"},[_vm._v("\n  Alle velden met\n  "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" zijn verplicht.\n")])}]

export { render, staticRenderFns }